// Centralized constants for Agent Voice Settings
export const AGENT_TONE_VALUES = [
    'professional',
    'friendly',
    'direct',
    'polite',
    'personable',
    'casual',
    'enthusiastic',
    'formal',
];
export const VOICE_OPTIONS = [
    {
        id: 'en-US-Chirp3-HD-Achernar',
        label: 'Allie',
        description: 'Default voice',
    },
    {
        id: 'en-US-Chirp3-HD-Zephyr',
        label: 'Zoe',
        description: 'Friendly voice',
    },
    {
        id: 'en-US-Chirp3-HD-Kore',
        label: 'Kayla',
        description: 'Professional voice',
    },
    {
        id: 'en-US-Chirp3-HD-Laomedeia',
        label: 'Lauren',
        description: 'Assertive voice',
    },
    {
        id: 'en-US-Chirp3-HD-Gacrux',
        label: 'Gabriela',
        description: 'Nurturing voice',
    },
    {
        id: 'en-US-Chirp3-HD-Schedar',
        label: 'Scott',
        description: 'Approachable voice',
    },
    {
        id: 'en-US-Chirp3-HD-Sadachbia',
        label: 'Samuel',
        description: 'Comforting voice',
    },
    {
        id: 'en-US-Chirp3-HD-Charon',
        label: 'Charlie',
        description: 'Professional voice',
    },
    {
        id: 'en-US-Chirp3-HD-Erinome',
        label: 'Erin',
        description: 'Cheerful voice',
    },
];
export const STAFF_CONNECTION_METHOD_VALUES = [
    'SIMPLE_TRANSFER',
    'AI_TRANSFER',
];
export const VOICE_SETTINGS_DEFAULTS = {
    name: '',
    temperature: 0.75,
    tone: [],
    active: true,
    disallowedTopics: '',
    greeting: '',
    voice: 'Allie',
    voiceModelId: 'en-US-Chirp3-HD-Achernar',
    voiceModelLLM: 'gpt-4o-mini',
    voiceModelSTT: 'nova-3',
    aiTransfersEnabled: false,
    enableTypingInBackground: false,
    declinedMessage: '',
};
//# sourceMappingURL=agent-voice-settings-constants.js.map